exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#preloader {\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 999;\n    width: 100%;\n    height: 100%;\n    overflow: visible;\n    background: #fbfbfb\n        url(\"//cdnjs.cloudflare.com/ajax/libs/file-uploader/3.7.0/processing.gif\")\n        no-repeat center center;\n}\n.preloader-visible {\n    visibility: visible;\n    opacity: 1;\n    transition: opacity 2s linear;\n}\n.preloader-hidden {\n    visibility: hidden;\n    opacity: 0;\n    transition: visibility 0s 2s, opacity 2s linear;\n}\n", ""]);

// exports
